import { type ReactElement } from 'react'
import * as S from './banner.styled'
import banner from './assets/hero-acredite-nos-sonhos.png'
import benefits from './benefits'
import { Swiper } from '../swiper/swiper'
import BenefitCard from '../benefit-card/benefit-card'
import { LinkButton } from '../button/link-button'

export function Banner (): ReactElement {
  return <S.Container>
    <S.BackgroundContainer>
      <S.Content>
        <S.TopContent>
          <S.TextContent>
            <h1>Tem descontos em consultas, exames, farmácias e dindim de volta nas suas compras</h1>
            <S.Cards className="mobile">
              <div>
                <p>
                  Consultas a partir de
                  <br/>
                  <span><small>R$</small>30</span>
                  <br/>
                  <strong>Clínico geral</strong>
                </p>
              </div>
              <div>
                <p>
                  <strong>Demais áreas médicas</strong>
                  <br />
                  a partir de
                  <br/>
                  <span><small>R$</small>40</span>
                </p>
              </div>
            </S.Cards>
            <LinkButton to="https://idpv.cartaodetodos.com.br/dados-pessoais/?from_lead=1&idpv=593fe813-3579-442f-b0c2-17a883e92e24">Peça o seu cartão!</LinkButton>
          </S.TextContent>
          <figure>
            <img src={banner} alt="" />
          </figure>
          <S.Cards className="desktop">
            <div>
              <p>
                Consultas a partir de
                <br/>
                <span><small>R$</small>30</span>
                <br/>
                <strong>Clínico geral</strong>
              </p>
            </div>
            <div>
              <p>
                <strong>Demais áreas médicas</strong>
                <br />
                a partir de
                <br/>
                <span><small>R$</small>40</span>
              </p>
            </div>
          </S.Cards>
        </S.TopContent>
        <S.Benefits>
          <Swiper className="swiper" offset={24}>
            {benefits.map((benefit, index) => <BenefitCard key={index} description={benefit.description} icon={benefit.icon} title={benefit.title} />)}
          </Swiper>
        </S.Benefits>
      </S.Content>
    </S.BackgroundContainer>
  </S.Container>
}
